import { Alert, Anchor } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useSelector } from 'react-redux';

const CredentialsAlert = ({ entityType }) => {
  const { domain } = useSelector((state) => state.domain);
  const facebook = useSelector((state) => state.facebook);

  const pageAndUrlMap = {
    textMessage: {
      page: 'Text Message',
      url: `#/accounts/${domain.accountId}/domains/${domain.id}/settings/messagingAndAds?tab=textMessage`,
      credentialsMissing:
        !domain.textMessageSender || !domain.textMessageSenderUser || !domain.textMessageSenderPassword,
    },
    viberMessage: {
      page: 'Viber Message',
      url: `#/accounts/${domain.accountId}/domains/${domain.id}/settings/messagingAndAds?tab=viberMessage`,
      credentialsMissing:
        !domain.viberMessageSender ||
        ((!domain.viberMessageSenderUser || !domain.viberMessageSenderPassword) &&
          (!domain.viberMessageSenderUser ||
            !domain.viberMessageSenderPassword ||
            !domain.viberDisplayName ||
            !domain.viberSenderId)),
    },
    facebookAd: {
      page: 'Facebook Ads',
      url: `#/accounts/${domain.accountId}/domains/${domain.id}/settings/meta?tab=general`,
      credentialsMissing: !facebook.user,
    },
  };

  if (!pageAndUrlMap[entityType]?.credentialsMissing) {
    return null;
  }

  const { page, url } = pageAndUrlMap[entityType];

  return (
    <Alert color="cyan" icon={<IconAlertTriangle size={18} />} mb="sm">
      Please fill in your {page} credentials because we cannot send messages without them!{' '}
      <Anchor href={url} fw={500}>
        You can fill your credentials here.
      </Anchor>
    </Alert>
  );
};

export default CredentialsAlert;
